import { Link } from "react-router-dom";

function Card(props) {
  return (
    <Link to={`/accomodation/${props.id}`}>
      <div className="card" id={props.id}>
        <div className="card__bg">
          <img src={props.cover} alt="lien vers la page du logement"></img>
          <div className="card__header">{props.title}</div>
        </div>
      </div>
    </Link>
  );
}

export default Card;
